export const body = `
We are sorry to tell you that this project has ended due to 
newer versions of the underlying systems being released.
We are working on a new version. Please stay connected to know
more and the link of the new website shall be posted soon!
`;
